import { createFileRoute } from '@tanstack/react-router';

import { AccountDetailsPage } from '@/features/user-profile/components/account-details-page';
import { requireAuthenticatedRoute } from '@/lib/router-guards';

export const Route = createFileRoute('/_app/account-details')({
    beforeLoad: requireAuthenticatedRoute,
    component: AccountDetailsPage
});
